/* @flow */
import React from 'react';
import { graphql, createFragmentContainer } from 'react-relay';
import { ListItem } from 'material-ui/List';
import ActionInfo from 'material-ui/svg-icons/action/info';
import Avatar from 'material-ui/Avatar';

import Duration from '../../../components/Duration';
import DateTime from '../../../components/DateTime';
import type { StudentJobSessionBooked_session } from './__generated__/StudentJobSessionBooked_session.graphql';

type Props = {
  session: StudentJobSessionBooked_session,
};

const StudentJobSessionBooked = ({
  session: { timeSlot, job, number },
}: Props) => {
  const { acceptedJobOffer, sessionCount } = job;
  const { tutor, jobRequest } = acceptedJobOffer;
  const { grade, subject } = jobRequest;
  const { fullname, profilePictureUri } = tutor;

  const secondaryText =
    sessionCount > 1
      ? `${fullname} - (${number} of ${sessionCount + 1})`
      : fullname;

  return (
    <ListItem
      leftAvatar={<Avatar src={profilePictureUri} />}
      rightIcon={<ActionInfo />}
      primaryText={
        <div>
          <Duration {...timeSlot.duration} />
          {` of ${subject.name} (${grade.name}) `}
          <DateTime value={timeSlot.startDate} />
        </div>
      }
      secondaryText={secondaryText}
    />
  );
};

export default createFragmentContainer(StudentJobSessionBooked, {
  session: graphql`
    fragment StudentJobSessionBooked_session on JobSession {
      id
      number
      timeSlot {
        startDate
        duration {
          hours
          minutes
        }
      }
      job {
        id
        sessionCount
        status
        createdAt
        acceptedJobOffer {
          tutor {
            fullname
            profilePictureUri
          }
          jobRequest {
            subject {
              name
            }
            grade {
              name
            }
          }
        }
      }
    }
  `,
});



// WEBPACK FOOTER //
// ./src/modules/admin/student/components/StudentJobSessionBooked.js